module.exports = __webpack_public_path__ + "img/check.1b495a5b.png";